module.exports = __webpack_public_path__ + "static/media/cog.d92d7352.svg";